import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/marketing/Navbar";
import { SquaresFour, Tray, Globe, SignOut } from "@phosphor-icons/react";

export default function PortalLayout({ title, subtitle, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/portal/login");
  };

  return (
    <div data-testid="portal-layout" className="min-h-screen bg-navy-950 flex">
      <aside className="hidden md:flex w-64 shrink-0 flex-col bg-navy-900/60 backdrop-blur border-r border-white/10 p-6 fixed inset-y-0">
        <Link to="/" data-testid="portal-brand-link" className="mb-12"><BrandMark compact /></Link>
        <nav className="flex flex-col gap-2 flex-1">
          {user?.role === "admin" ? (
            <Link to="/admin" data-testid="portal-nav-enquiries"
              className="flex items-center gap-3 px-4 py-3 text-sm text-mist hover:text-gold hover:bg-gold/10 transition-colors">
              <Tray size={18} weight="duotone" /> Enquiries & Filings
            </Link>
          ) : (
            <Link to="/portal" data-testid="portal-nav-dashboard"
              className="flex items-center gap-3 px-4 py-3 text-sm text-gold bg-gold/10">
              <SquaresFour size={18} weight="duotone" /> My Filings
            </Link>
          )}
          <Link to="/" data-testid="portal-nav-site"
            className="flex items-center gap-3 px-4 py-3 text-sm text-mist hover:text-gold hover:bg-gold/10 transition-colors">
            <Globe size={18} weight="duotone" /> Back to site
          </Link>
        </nav>
        <button onClick={handleLogout} data-testid="portal-logout-button"
          className="flex items-center gap-3 px-4 py-3 text-sm text-mist hover:text-red-400 transition-colors">
          <SignOut size={18} /> Sign out
        </button>
      </aside>

      <main className="flex-1 md:ml-64 p-6 sm:p-10">
        <div className="md:hidden flex items-center justify-between mb-8">
          <Link to="/"><BrandMark compact /></Link>
          <button onClick={handleLogout} data-testid="portal-logout-button-mobile" className="text-mist text-sm">Sign out</button>
        </div>
        <header className="mb-10">
          <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold mb-2">
            {user?.role === "admin" ? "Administration" : `Welcome, ${user?.name || ""}`}
          </p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl text-white tracking-tight">{title}</h1>
          {subtitle && <p className="text-mist mt-3 text-sm">{subtitle}</p>}
        </header>
        {children}
      </main>
    </div>
  );
}
